import { confirm, custom } from 'devextreme/ui/dialog';
import notify from 'devextreme/ui/notify';
import { Injectable } from '@angular/core';

// export class DialogResult {

//     constructor(resolve: () => void, reject: () => void) {
//         resolve = this.okayAction;
//         reject = this.cancelAction;
//         console.log("1-constructor",resolve);
//     }

//     private okayAction: () => void;
//     private cancelAction: () => void;

//     okay(action: () => void): DialogResult {
//         console.log("2-action", action);
//         this.okayAction = action;
//         return this;
//     }
//     cancel(action: () => void): DialogResult {
//         this.cancelAction = action;
//         return this;
//     }
// }

@Injectable()
export class UIService {

    constructor() {
    }

    custom(title: string, message: string, buttons: any[]): Promise<any> {
        if (buttons) {
            buttons.forEach(button => {
                button.onClick = (e) => {
                    return { name: e[0].component.option('name') };
                };
            });
        }
        const myDialog = custom({
            title: title,
            message: message,
            buttons: buttons.concat({
                text: 'Cancel',
                onClick: (e) => {
                    myDialog.hide();
                }
            })
        });


        return new Promise<any>((resolve, reject) => {
            myDialog.show().then((dialogResult) => {
                if (dialogResult) {
                    resolve(dialogResult);
                }
                else {
                    reject();
                }
            });
        });
    }

    confirm(title: string, message: string): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            confirm(message, title).then((dialogResult) => {
                if (dialogResult)
                    resolve(true);
                else
                    reject(false);
            });
        });
    }

    delete(): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            let message: string = "Are you sure you want to delete these item(s)?";
            confirm(message, "Delete Item(s)").then((dialogResult) => {
                if (dialogResult)
                    resolve(true);
                else
                    reject(false);
            });
        });
    }

    error(message: string = null) {
        notify({
            message: message || "The action failed!",
            type: "error",
            width: 400,
            displayTime: 5000,
        });
    }

    success(message: string = null) {
        notify({
            message: message || "The action has been done successfully!",
            type: "success",
            width: 400,
            displayTime: 5000,
        });
    }
}


// WEBPACK FOOTER //
// D:/Works/Safetyminder/Safetyminder/Admin/src/app/shared/services/UIService.ts